import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
    selector: 'mapp-resources-card',
    templateUrl: './resources-card.component.html',
    styleUrls: ['./resources-card.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ResourcesCardComponent {
    @Input() information: {
        img: string;
        icon: string;
        Document_Name: string;
        Link: string;
    };

    @Input() sourceData;

    @Input() indexData;
}
